import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useSearchParams, useNavigate } from "react-router-dom";

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const verifyAndUpdatePayment = async () => {
      const registrationId = searchParams.get("registrationId");

      if (!registrationId) {
        Swal.fire("Error", "Missing registration ID in URL.", "error");
        setLoading(false);
        return;
      }

      try {
        // Optional: Show a loading spinner
        setLoading(true);

        // 1. Verify payment status from PayPal (via your backend)
        const verifyResponse = await axios.get(
          `https://api.adyapeathusa.org/index.php/paypal/verify_paypal_order/${registrationId}`
        );

        if (
          verifyResponse.data &&
          verifyResponse.data.status &&
          verifyResponse.data.status === "COMPLETED"
        ) {
          // 2. Update registration status
          await axios.post(
            `https://api.adyapeathusa.org/index.php/paypal/update_payment_status`,
            {
              id: registrationId,
              paymentstatus: "COMPLETED",
              orderid: verifyResponse.data.orderID, // if returned from verify
            }
          );

          Swal.fire("Payment Successful", "Thank you for registering!", "success").then(() => {
            navigate("/thank-you"); // or any confirmation page
          });
        } else {
          Swal.fire("Payment Failed", "Payment was not completed.", "error");
        }
      } catch (error) {
        console.error("Payment verification failed:", error);
        Swal.fire("Error", "Could not verify your payment. Please contact support.", "error");
      } finally {
        setLoading(false);
      }
    };

    verifyAndUpdatePayment();
  }, [searchParams, navigate]);

  return (
    <div className="container text-center mt-5">
      {loading ? (
        <div>
          <h3>Verifying your payment...</h3>
          <p>Please wait, this may take a few seconds.</p>
        </div>
      ) : (
        <div>
          <h3>Processing Complete</h3>
        </div>
      )}
    </div>
  );
};

export default PaymentSuccess;
